<div class="metrics-row">
  <div class="metric-card">
    <div class="metric-label">Total {{ numSemanas }} {{ numSemanas === 1 ? 'semana' : 'semanas' }}</div>
    <div class="metric-value">{{ formatShort(totalPesosPeriodo) }}</div>
    <div class="metric-sub">{{ formatMoney(totalKgPeriodo) }} Kg vendidos</div>
  </div>
  <div class="metric-card">
    <div class="metric-label">Semana actual</div>
    <div class="metric-value">
      {{ formatShort(semanaActual.totalPesos) }}
      <span class="metric-badge" [class.neg-badge]="semanaActual.pct < 0">{{ semanaActual.pct > 0 ? '+' : '' }}{{ semanaActual.pct }}%</span>
    </div>
    <div class="metric-sub">
      {{ formatMoney(semanaActual.totalKg) }} Kg
      <span class="metric-badge sm" [class.neg-badge]="semanaActual.pctKg < 0">{{ semanaActual.pctKg > 0 ? '+' : '' }}{{ semanaActual.pctKg }}% Kg</span>
    </div>
  </div>
  <div class="metric-card">
    <div class="metric-label">Prom. semanal — {{ numSemanas }} {{ numSemanas === 1 ? 'sem.' : 'sems.' }}</div>
    <div class="metric-value">
      {{ formatShort(promSemanal) }}
      <span class="metric-badge" [class.neg-badge]="promCrecimiento < 0">{{ promCrecimiento > 0 ? '+' : '' }}{{ promCrecimiento }}%</span>
    </div>
    <div class="metric-sub">
      {{ formatMoney(totalKgPeriodo / numSemanas) }} Kg
      <span class="metric-badge sm" [class.neg-badge]="promCrecimientoKg < 0">{{ promCrecimientoKg > 0 ? '+' : '' }}{{ promCrecimientoKg }}% Kg</span>
    </div>
  </div>
</div>
